/**
 * <accessibility-trigger> — the footer's Accessibility control.
 *
 * The live site carries an Accessibility entry in the footer that opens the store's accessibility
 * widget, which is an installed service rather than part of the theme. This element renders that
 * entry only once such a widget is actually on the page, so it never shows a control that does
 * nothing, and clicking it opens the widget through the widget's own trigger.
 */
const WIDGET_TRIGGERS = [
  '.acsb-trigger',
  '#acsbWidget button',
  '[aria-label="Open accessibility options, statement and help" i]',
  '[data-accessibility-widget-trigger]',
];

class AccessibilityTrigger extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.open);
    this.reveal();
    window.addEventListener('load', this.reveal);
    // widgets are usually injected after load, so look once more a little later
    this.timer = setTimeout(this.reveal, 2500);
  }

  disconnectedCallback() {
    window.removeEventListener('load', this.reveal);
    clearTimeout(this.timer);
  }

  get widgetTrigger() {
    for (const selector of WIDGET_TRIGGERS) {
      const element = document.querySelector(selector);
      if (element) return element;
    }
    return null;
  }

  reveal = () => {
    if (this.widgetTrigger) this.hidden = false;
  };

  open = () => {
    this.widgetTrigger?.click();
  };
}

if (!customElements.get('accessibility-trigger')) {
  customElements.define('accessibility-trigger', AccessibilityTrigger);
}
